import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Loading from '../../components/loading';
import EssayItem from './components/essay-item';
import { EssayViewModel } from './essay.vm';
import {
  Breadcrumb,
  Container,
  EssayInfo,
  EssayInfoDetail,
  EssayInfoText,
  EssayInfoTime,
  EssayInfoTitle,
  EssayList,
  EssayListContainer,
  EssaySubTitle,
  EssayTitleWrapper,
  Title,
} from './styles';

const DESKTOP_COLUMNS = 4;
const TABLET_COLUMNS = 3;
const MOBILE_COLUMNS = 1;
const DESKTOP_DISPLAY_LENGTH = 4;
const TABLET_DISPLAY_LENGTH = 3;
const MOBILE_DISPLAY_LENGTH = 3;

export const AllEssay: React.FC = () => {
  const vm = useViewModel(EssayViewModel);
  const navigate = useNavigate();

  const [, setDisplayLength] = useState(DESKTOP_DISPLAY_LENGTH);
  const [columns, setColumns] = useState(DESKTOP_COLUMNS);

  const openEssay = () => {
    navigate('/essays');
  };

  useEffect(() => {
    if (vm.hasError) {
      navigate('/library');
    }
  }, [vm.hasError, navigate]);

  useEffect(() => {
    const updateLayout = () => {
      const width = window.innerWidth;
      if (width <= 640) {
        setColumns(MOBILE_COLUMNS);
        setDisplayLength(MOBILE_DISPLAY_LENGTH);
      } else if (width <= 1024) {
        setColumns(TABLET_COLUMNS);
        setDisplayLength(TABLET_DISPLAY_LENGTH);
      } else {
        setColumns(DESKTOP_COLUMNS);
        setDisplayLength(DESKTOP_DISPLAY_LENGTH);
      }
    };

    window.addEventListener('resize', updateLayout);
    updateLayout();

    return () => {
      window.removeEventListener('resize', updateLayout);
    };
  }, []);

  if (vm.isLoading || !vm.essays) {
    return <Loading />;
  }

  const essayItemsArray = vm.essays?.data;

  return (
    <Container>
      <Breadcrumb onClick={() => openEssay()}>Redação / Minhas redações</Breadcrumb>
      <Title>Redações</Title>

      <EssayListContainer>
        <EssayTitleWrapper>
          <EssaySubTitle>Minhas redações</EssaySubTitle>
          <EssayInfo>
            <EssayInfoTitle>Média total das suas redações</EssayInfoTitle>
            <EssayInfoTime>
              <EssayInfoText>{vm.essays?.metadata.enemFeedback.overallScore}</EssayInfoText>
              <EssayInfoDetail>/1000</EssayInfoDetail>
            </EssayInfoTime>
          </EssayInfo>
        </EssayTitleWrapper>

        <Breadcrumb onClick={() => openEssay()}> {`< Voltar`}</Breadcrumb>
        <EssayList columns={columns}>
          {essayItemsArray.map((essay, i) => {
            return (
              <EssayItem
                key={i}
                essayGuid={essay.id}
                essayStatus={essay.status}
                essayDescription={essay.content}
                essayTitle={essay.title}
                essayScore={essay?.enemFeedback?.overallScore}
              />
            );
          })}
        </EssayList>
      </EssayListContainer>
    </Container>
  );
};

export default observer(AllEssay);
